import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";

const { Option, OptGroup } = Select;

class SelectLeadsItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: true,
      texto: "",
    };

    this.buscarLeads = debounce(this.buscarLeads.bind(this), 300);
  }

  componentDidMount() {
    this.buscarLeads("");
    if (this.props.value) this.asegurarValor(this.props.value);
  }

  componentDidUpdate(prevProps) {
    const prevVal = prevProps.value?.toString();
    const currVal = this.props.value?.toString();
    if (prevVal !== currVal && currVal) {
      this.asegurarValor(currVal);
    }
  }

  async asegurarValor(value) {
    const val = value?.toString();
    if (!val) return;

    const encontrado = this.state.opciones.find(
      (l) => l._id?.toString() === val,
    );
    if (encontrado) {
      this.props.onChange?.(encontrado._id, encontrado);
      return;
    }

    try {
      const res = await axios.post(
        "leads/selectLeadsItem",
        { query: val, skip: 0, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      );
      if (res.data.success === 2 && res.data.leads?.length) {
        const leadTarget = res.data.leads.find(
          (l) => l._id.toString() === val,
        );
        this.setState((prev) => {
          const existentes = new Set(
            prev.opciones.map((o) => o._id?.toString()),
          );
          const nuevos = res.data.leads.filter(
            (l) => !existentes.has(l._id?.toString()),
          );
          return { opciones: [...nuevos, ...prev.opciones] };
        });
        if (leadTarget) this.props.onChange?.(leadTarget._id, leadTarget);
      }
    } catch (error) {
      console.error("Error al asegurar el lead seleccionado:", error);
    }
  }

  async buscarLeads(texto, append = false) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "leads/selectLeadsItem",
        {
          query: append
            ? this.state.texto || texto || this.props.value?.toString()
            : texto || "",
          skip: append ? this.state.opciones.length : 0,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken },
      );

      if (res.data.success === 2) {
        this.setState((prev) => ({
          opciones: append
            ? [...prev.opciones, ...res.data.leads]
            : res.data.leads,
          primerCarga: false,
          texto: append ? prev.texto : texto,
        }));
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar leads:", error);
      this.setState({ opciones: [] });
    } finally {
      this.setState({ cargando: false });
    }
  }

  render() {
    const {
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      empresaId,
      headersToken,
      ...restProps
    } = this.props;

    const propsSelect = {
      showSearch: true,
      filterOption: false,
      onSearch: this.buscarLeads,
      notFoundContent: this.state.cargando ? (
        <div
          style={{
            textAlign: "center",
            padding: 8,
            fontSize: 12,
            color: "#999",
          }}
        >
          Buscando leads...
        </div>
      ) : this.state.primerCarga ? (
        "Cargando..."
      ) : (
        "No se encontraron leads"
      ),
      loading: this.state.cargando,
    };

    const estiloFinal = {
      color: disabled ? "black" : "inherit",
      backgroundColor: disabled ? "white" : null,
      borderBottom: sinBorde ? "none" : "1px solid #E0FFFFFF",
      borderRadius: 4,
      boxShadow: sinBorde ? "none" : "0 1px 3px rgba(0,0,0,0.1)",
      width: width || "100%",
      opacity: disabled ? 1 : undefined,
      ...style,
    };

    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={false}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>{menu}</Spin>
        )}
        {...propsSelect}
        {...restProps}
        onChange={(value) => {
          const lead = this.state.opciones.find((l) => l._id === value);
          this.props.onChange?.(value, lead);
        }}
        placeholder={
          this.state.cargando && this.state.primerCarga
            ? "Cargando..."
            : placeholder || "Buscar lead..."
        }
        style={estiloFinal}
        bordered={!sinBorde}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            this.buscarLeads("", true);
          }
        }}
      >
        {this.agruparPorEmbudo(this.state.opciones).map(({ nombreEmbudo, leads }) => (
          <OptGroup key={nombreEmbudo} label={nombreEmbudo}>
            {leads.map((lead) => (
              <Option key={lead._id} value={lead._id}>
                <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {/* Descripción del lead */}
                  <span style={{ fontWeight: 600, fontSize: 13 }}>
                    {lead.descripcion}
                  </span>

                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    {/* Contacto */}
                    {lead.nombreContacto && (
                      <span style={{ fontSize: 11, color: "#888" }}>
                        {lead.nombreContacto}
                      </span>
                    )}

                    {/* Etapa dentro del embudo */}
                    {lead.nombreEtapa && (
                      <span
                        style={{
                          fontSize: 10,
                          color: lead.colorEtapa,
                          border: `1px solid ${lead.colorEtapa}`,
                          borderRadius: 4,
                          padding: "0 4px",
                          lineHeight: "16px",
                        }}
                      >
                        {lead.nombreEtapa}
                      </span>
                    )}
                  </div>
                </div>
              </Option>
            ))}
          </OptGroup>
        ))}
      </Select>
    );
  }

  // Agrupa las opciones por embudo, preservando el orden en que aparece cada grupo.
  agruparPorEmbudo(opciones) {
    const grupos = [];
    const indice = new Map();
    opciones.forEach((lead) => {
      const nombreEmbudo = lead.nombreEmbudo || "Sin embudo";
      if (!indice.has(nombreEmbudo)) {
        indice.set(nombreEmbudo, { nombreEmbudo, leads: [] });
        grupos.push(indice.get(nombreEmbudo));
      }
      indice.get(nombreEmbudo).leads.push(lead);
    });
    return grupos;
  }
}

export default SelectLeadsItem;
